module.exports = __webpack_public_path__ + "img/quote.2c998405.svg";